/* eslint-disable max-len */

const BUSINESS_STORAGE_DATA = [
	{
		heading: "Business and Commercial Storage Solutions",
		description:
			"Self storage has a variety of uses. Most people recognize it for residential storage and a place to keep belongings while they are in-between living spaces. What most people don’t consider though is that storage units can be great tools for businesses, too. In fact, some businesses have begun running their entire operation out of storage units.",
		description2:
			"Compared to the cost of commercial real estate, business owners who use self-storage instead can enjoy significant savings on a cost per square foot basis. Many modern storage facilities provide amenities that small business customers need including convenient access and the ability to submit payments electronically."
	},
	{
		subHeadings: [
			{
				title: "Which types of businesses can benefit?",
				desc: "Several industries have found that commercial storage services offered by storage facilities can help their operations:"
			}
		],
		points: [
			{
				title: "Contractors. ",
				desc: "Renting self storage space allows them to save money when storing materials and equipment. Some even find that they can run their business without renting office space because of self storage."
			},
			{
				title: "Brick and mortar retail businesses. ",
				desc: "Many small business owners struggle to find a way to keep their inventory at their locations. This is especially true in larger cities where storage space is at a premium. These businesses turn to storage facilities to help house their inventory nearby. Storing excess inventory offsite is more economical than renting more on-site commercial space for storage purposes"
			},
			{
				title: "E-commerce retail businesses. ",
				desc: "Online resellers and drop shippers alike can use self-storage space to keep their retail inventory from overtaking their living rooms."
			},
			{
				title: "Realtors and other sales-oriented professionals. ",
				desc: "Businesses that use an abundance of signs and other marketing materials to get their names out can benefit from commercial storage units. These promotional materials can also take up a significant amount of space. If these items are taking over your garage or office space, using business storage would be a great option."
			},
			{
				title: "Small offices. ",
				desc: "Some offices have a wealth of supplies for their office space, including anything from toiletries and paper to additional desks and monitors. Offices that don’t have room for these supplies may choose to place them in a storage unit until they’re needed later on."
			}
		],
		description3:
			"These industries are only a few of the most notable. Businesses of all types have found that storage units can be beneficial to their operation."
	},
	{
		heading: "Why use business storage?",
		description:
			"Self storage units are capable of helping businesses improve their overall operations in multiple ways. A few of the most notable benefits include:",
		subHeadings: [
			{
				title: "Saving Money",
				desc: "Saving money is something that all businesses are looking to do. With the technology available today, many local businesses are finding ways to operate without a true office. But they often still need a place to keep their materials and equipment. Self storage facilities offer this space and at much lower rates than renting an office or warehouse."
			},
			{
				title: "Prime Locations",
				desc: "For businesses that are traveling all over town to get to their next job, location can be incredibly important. Even if a business is renting space because they ran out of it at their office, location is important. With so many storage facilities to choose from on Storage.com, businesses can easily find the location that works best for them. With the extra money that has been saved by using self storage, these businesses might even consider renting multiple units in different areas of town to make their operations more efficient."
			},
			{
				title: "Business Centers",
				desc: "If your business loves the convenience and affordability of a self storage unit but still needs a true office space to hold meetings and other functions, you are in luck. Many storage locations throughout the nation offer business centers that provide office space, phone lines, and Internet connectivity. With all of these things available, businesses are able to run their entire operation from just one place."
			}
		]
	},
	{
		heading: "Popular amenities for business storage",
		description:
			"If your business plans on using self storage to help with daily functions, there are many helpful features that storage facilities offer. Depending on what you’ll be using the storage unit for and what type of business you own, you may want all of these features or just a few.",
		subHeadings: [
			{
				title: "Electrical Outlets",
				desc: "With electrical outlets becoming increasingly available in storage units, it’s a popular choice for businesses that utilize self storage. Business storage units with electricity give way to the possibility of using special equipment in storage or for using the unit as an office space. If it is allowed by the facility, that is."
			},
			{
				title: "Security",
				desc: "If your business is going to use the storage unit for excess products or supplies, you’re going to want those products or supplies to be safe. Many storage facilities offer security features like video surveillance, gated access, and on-site management."
			},
			{
				title: "24/7 Access",
				desc: "For many businesses that use storage, the ability to access what’s in their storage units cannot be hindered by time restraints. If your company needs to have the freedom of grabbing supplies at all hours, a storage facility with 24-hour access is the ideal solution."
			},
			{
				title: "Drive-Up Access",
				desc: "When using a storage unit for business purposes, it can be critical to access the unit frequently. If this is the case, a drive-up storage unit can be beneficial to your business, saving valuable time. If storing large items, drive-up access makes it easy to load and unload with less stress and zero stairs."
			},
			{
				title: "Delivery Acceptance",
				desc: "Some self-storage facilities may offer delivery acceptance, which is hugely important when using a self-storage unit for commercial purposes. Many storage facilities also double as packaging drop off and pick up centers for UPS or FedEx.",
				desc2: "Self storage is a great option for businesses looking to improve their operations and save money at the same time. Using Storage.com to find a business storage unit makes the process fast and easy, and allows you to find the best deals all in one place."
			}
		]
	},
	{
		heading: "Business Storage FAQs",
		description:
			"If your business plans on using self storage to help with daily functions, there are many helpful features that storage facilities offer. Depending on what you’ll be using the storage unit for and what type of business you own, you may want all of these features or just a few.",
		subHeadings: [
			{
				title: "Can any storage unit be used for commercial or business purposes?",
				desc: "It’s important to talk with your storage operator before assuming you can use a storage unit for commercial purposes. Many facilities have rules in place to prevent people from operating a business directly out of a storage unit, but using one for storing business-related items is usually fine. For example, you probably won't be able to make phone calls or conduct meetings inside of a storage unit."
			},
			{
				title: "Do most storage facilities offer business or commercial storage?",
				desc: "Most self storage facilities do not specifically offer “business storage units” or “commercial storage units”. There are a select few that provide meeting rooms, WiFi, and other business-friendly features, but they aren’t commonly used. Instead, it’s better to simply decide what common self storage features you will need for your business’ needs, and choose a unit that meets your requirements. If you need more space or amenities than a standard self-storage unit can provide, then you may need to look for commercial warehouse storage to lease instead."
			},
			{
				title: "Will I be able to get a large truck in and out of the facility",
				desc: "Many facilities provide ample room for maneuvering larger moving trucks and vans, so it shouldn’t be a problem. Keep an eye out for facilities that advertise wide driving aisles to be on the safe side. Also, be sure to check with your storage operator beforehand to see if it’s okay that you drive a large truck in and out of their facility frequently."
			}
		]
	}
];

export { BUSINESS_STORAGE_DATA };
